import {
  computeNativeId,
  type NativeId,
} from '@packages/systems/core/utils/NativeIdUtils';
import type {EnvironmentContextType} from '@packages/systems/wfdl';
import {getOverlayDomId} from '../shared/ids';

const MODAL_DOM_ID_PREFIX = 'w-modal-';

export const getModalDomId = (
  runtimeNativeIdPath: readonly NativeId[]
): string => getOverlayDomId(MODAL_DOM_ID_PREFIX, runtimeNativeIdPath);

export const getModalElementDomId = (
  elementId: string,
  nativeIdPath: readonly NativeId[],
  environmentContext: EnvironmentContextType
): string =>
  getModalDomId([
    ...nativeIdPath,
    computeNativeId(elementId, environmentContext),
  ]);
